import axios from "axios";

const createFocs = async (Foc) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/Focs`, Foc)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllFocs = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/Focs`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getFocs = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/Focs/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editFocs = async (id, Foc) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/Focs/${id}`, Foc)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteFocs = async (id, force) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/Focs/${id}?force=${force}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const FocService = { createFocs, getAllFocs, getFocs, editFocs, deleteFocs };

export default FocService;
